import { combineReducers } from 'redux';

import resetPassword from './resetpassword/reducer';
import login from './login/reducer';

export default combineReducers({
  resetPassword,
  login,
});



// WEBPACK FOOTER //
// ./src/pages/login/state/reducer.js